/**
 * Configuration for the Search API V2
 */
export default {
	id: 'searchV2',
	name: 'Search',
	resultsTitle: 'Search',
	version: 'v2',
	fields: [
		{
			name: 'User Query',
			placeholder: 'Enter query string...',
			required: true,
			value: '',
			id: 'query',
			type: 'text',
		},
		{
			name: 'Facets',
			placeholder: '',
			required: false,
			value: null,
			id: 'facets',
			type: 'facets',
		},
		{
			name: 'Order by',
			placeholder: 'Select an order...',
			required: false,
			value: 'Relevance',
			id: 'orderBy',
			type: 'select',
			options: [
				{
					value: 'Relevance',
					name: 'Relevance',
				},
				{
					value: 'PublishedDate',
					name: 'Published Date',
				},
				{
					value: 'Recent',
					name: 'Recent',
				},
				{
					value: 'LastUpdatedDate',
					name: 'Last Updated Date',
				},
				{
					value: 'LastOptimizedDate',
					name: 'Last Optimized Date',
				},
				{
					value: 'AverageRating',
					name: 'Average Rating',
				},
				{
					value: 'ReviewsCount',
					name: 'Review Count',
				},
				{
					value: 'UGCRelevance',
					name: 'UGC Ratings/Reviews and Relevance',
				},
				{
					value: 'TotalCooktimeMinutes',
					name: 'Total Cook Time',
				},
				{
					value: 'BabyNamePopularity',
					name: 'Baby Name Popularity',
				},
			],
		},
		{
			name: 'Source',
			placeholder: 'Enter sources...',
			required: false,
			value: null,
			id: 'sourceFilter',
			type: 'csv',
			autoComplete: '/api/autocomplete/brands',
		},
		{
			name: 'Content-types',
			placeholder: 'Enter content types...',
			required: false,
			value: null,
			id: 'docTypeFilter',
			type: 'csv',
			autoComplete: '/api/autocomplete/types',
		},
		{
			name: 'Variants',
			placeholder: 'Enter variants...',
			required: false,
			value: null,
			id: 'variantFilter',
			type: 'csv',
			autoComplete: '/api/autocomplete/variants',
		},
		{
			name: 'Start Date',
			placeholder: 'Click to select a start date',
			required: false,
			value: null,
			id: 'startDate',
			type: 'datetime',
		},
		{
			name: 'End Date',
			placeholder: 'Click to select an end date',
			required: false,
			value: null,
			id: 'endDate',
			type: 'datetime',
		},
		{
			name: 'Page',
			placeholder: 'Page',
			required: false,
			value: 1,
			id: 'page',
			type: 'page',
		},
		{
			name: 'Page Size',
			placeholder: 'Size',
			required: false,
			value: 20,
			id: 'pageSize',
			type: 'pageSize',
		},
	],
};
